import DropDown from "../../assets/svg/Drop-Down.svg";
const Faqs = () => {
  const FaqList = [
    {
      title: "HOW DO I START THE PROCESS TO BECOME A DEALER?",
      subTitle:
        "Complete the New Dealer Inquiry Form. One of our Dealer Development team members will contact you shortly.",
    },
    {
      title: "DO I HAVE TO CARRY TUATARA’S FULL PRODUCT LINE?",
      subTitle:
        "We understand that you may only like to carry products that you are confident in your ability to sell and service appropriately.",
    },
    {
      title: "CAN I CARRY OTHER BRANDS?",
      subTitle:
        "Multi-brand dealerships are acceptable. A Tuatara representative will work with you to meet our requirements of representation in terms of inventory, display, signage, advertising, etc.",
    },
    {
      title: "WHAT ARE THE INITIAL COSTS/REQUIREMENTS TO BECOME A DEALER?",
      subTitle:
        "Your Dealer Development Manager will walk you through initial start­up costs, which vary based on product lines, service tools, branding, and training.",
    },
    {
      title: "ARE THERE MINIMUM ORDER REQUIREMENTS?",
      subTitle:
        "Yes, ther is a minimum initial order of six units, including a combination of at least one gas unit, one electric unit, and one 6-seat dual motor vehicle.",
    },
    {
      title: "CAN I FOLLOW-UP ON MY SUBMITTED DEALER INQUIRY FORM?",
      subTitle:
        "Yes, after submitting the Dealer Inquiry Form, you can follow-up by emailing: distribution@tuatarausa.com",
    },
  ];
  return (
    <div className="custom-container">
      <div className="flex font-[Rockwell] 2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold ">
        <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
          FREQUE
          <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
            {" "}
            NTLY ASKED QUESTIONS
          </span>
        </span>
      </div>

      <div class="grid 2xl:grid-cols-3 xl:grid-cols-2 grid-cols-1 gap-[40px] md:mt-[70px] sm:mt-[50px] mt-[20px]">
        {FaqList.map((item) => {
          return (
            <div
              className="bg-[#F2F2F2] border-[1px] border-[#7ABF5B] px-[24px] pb-[25px] pt-[39px]"
              style={{ boxShadow: "4px 8px 4px 0px #00000040" }}
            >
              <div className="font-[Roboto] 2xl:text-[26px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-bold flex items-start">
                <img src={DropDown} alt="" className="lg:w-[56px] md:w-[46px] sm:w-[36px] w-[26px]" />
                <div className="sm:ml-[26px] ml-[10px]"> {item?.title}</div>
              </div>
              <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-normal mt-[25px]">
                {item?.subTitle}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Faqs;
